/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_View_Toggle_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Event view mode" |
*
* @param {Editor_View_Toggle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_view_toggle_aria_label = /** @type {((inputs?: Editor_View_Toggle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_View_Toggle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode d'affichage des evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisansichtsmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità di visualizzazione degli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("режим просмотра событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de vista de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件视图模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントビューモード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट व्यू मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo de visualização de eventos")
	return /** @type {LocalizedString} */ ("Event view mode")
});